"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noPageable = exports.manyPagesLast = exports.manyPages = exports.empty = exports.notFirstOrLast = exports.lastButNotFirst = exports.firstButNotLast = exports.firstAndLast = void 0;
exports.firstAndLast = {
    content: [
        {
            data: true
        }
    ],
    pageable: {
        sort: {
            sorted: false,
            unsorted: true,
            empty: true
        },
        offset: 2,
        pageSize: 2,
        pageNumber: 0,
        unpaged: false,
        paged: true
    },
    totalElements: 22,
    totalPages: 1,
    last: true,
    size: 2,
    number: 0,
    numberOfElements: 2,
    sort: {
        sorted: false,
        unsorted: true,
        empty: true
    },
    first: true,
    empty: false
};
exports.firstButNotLast = {
    content: [
        {
            data: true
        }
    ],
    pageable: {
        sort: {
            sorted: false,
            unsorted: true,
            empty: true
        },
        offset: 2,
        pageSize: 2,
        pageNumber: 0,
        unpaged: false,
        paged: true
    },
    totalElements: 22,
    totalPages: 12,
    last: false,
    size: 2,
    number: 0,
    numberOfElements: 2,
    sort: {
        sorted: false,
        unsorted: true,
        empty: true
    },
    first: true,
    empty: false
};
exports.lastButNotFirst = {
    content: [
        {
            data: true
        }
    ],
    pageable: {
        sort: {
            sorted: false,
            unsorted: true,
            empty: true
        },
        offset: 2,
        pageSize: 2,
        pageNumber: 2,
        unpaged: false,
        paged: true
    },
    totalElements: 5,
    totalPages: 3,
    last: true,
    size: 2,
    number: 2,
    numberOfElements: 2,
    sort: {
        sorted: false,
        unsorted: true,
        empty: true
    },
    first: false,
    empty: false
};
exports.notFirstOrLast = {
    content: [
        {
            data: true
        }
    ],
    pageable: {
        sort: {
            sorted: false,
            unsorted: true,
            empty: true
        },
        offset: 2,
        pageSize: 2,
        pageNumber: 5,
        unpaged: false,
        paged: true
    },
    totalElements: 22,
    totalPages: 7,
    last: false,
    size: 2,
    number: 4,
    numberOfElements: 2,
    sort: {
        sorted: false,
        unsorted: true,
        empty: true
    },
    first: false,
    empty: false
};
exports.empty = {
    content: [],
    pageable: {
        sort: {
            sorted: false,
            unsorted: true,
            empty: true
        },
        offset: 0,
        pageSize: 0,
        pageNumber: 0,
        unpaged: false,
        paged: true
    },
    totalElements: 0,
    totalPages: 0,
    last: true,
    size: 0,
    number: 0,
    numberOfElements: 0,
    sort: {
        sorted: false,
        unsorted: true,
        empty: true
    },
    first: true,
    empty: true
};
exports.manyPages = {
    content: [
        {
            data: true
        }
    ],
    pageable: {
        sort: {
            sorted: false,
            unsorted: true,
            empty: true
        },
        offset: 2,
        pageSize: 2,
        pageNumber: 5,
        unpaged: false,
        paged: true
    },
    totalElements: 22,
    totalPages: 12,
    last: false,
    size: 2,
    number: 4,
    numberOfElements: 2,
    sort: {
        sorted: false,
        unsorted: true,
        empty: true
    },
    first: false,
    empty: false
};
exports.manyPagesLast = {
    content: [
        {
            data: true
        }
    ],
    pageable: {
        sort: {
            sorted: false,
            unsorted: true,
            empty: true
        },
        offset: 2,
        pageSize: 2,
        pageNumber: 10,
        unpaged: false,
        paged: true
    },
    totalElements: 22,
    totalPages: 12,
    last: true,
    size: 2,
    number: 10,
    numberOfElements: 2,
    sort: {
        sorted: false,
        unsorted: true,
        empty: true
    },
    first: false,
    empty: false
};
exports.noPageable = {
    content: [
        {
            data: true
        }
    ],
    pageable: undefined,
    totalElements: 22,
    totalPages: 7,
    last: false,
    size: 2,
    number: 4,
    numberOfElements: 2,
    sort: {
        sorted: false,
        unsorted: true,
        empty: true
    },
    first: false,
    empty: false
};
//# sourceMappingURL=pageables.js.map